<template>
  <div class="qualifying-benefits mt-4">

    <div class="module module-1">
      <div class="img-wrap">
        <img src="/images/emirates/benefit-1_d.jpg" class="d-none d-sm-inline" alt="">
        <img src="/images/emirates/benefit-1_m.jpg" class="d-sm-none" alt="">
      </div>
      <div class="copy-wrap">
        <Dropdown
          @dropdown-event="onSelectMarriottLevel($event)"
          :id="1"
          :data="content.marriott_list"
          placeholder="Select Your Marriott Bonvoy Status"
          type="marriott"
          :selectedLevel="selectedMarriottLevel"
        ></Dropdown>

        <DropdownBenefits :selectedLevel="selectedMarriottLevel"></DropdownBenefits>
      </div>
    </div>

    <div class="module module-2">
      <div class="img-wrap">
        <img src="/images/emirates/benefit-2_d.jpg" class="d-none d-sm-inline" alt="">
        <img src="/images/emirates/benefit-2_m.jpg" class="d-sm-none" alt="">
      </div>
      <div class="copy-wrap">
        <Dropdown
          @dropdown-event="onSelectSkywardsLevel($event)"
          :id="2"
          :data="content.skywards_list"
          placeholder="Select Your Emirates Skywards Tier"
          type="partner"
          :selectedLevel="selectedSkywardsLevel"
        ></Dropdown>

        <DropdownBenefits :selectedLevel="selectedSkywardsLevel"></DropdownBenefits>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref } from 'vue';
import Dropdown from '../Dropdown.vue';
import DropdownBenefits from './DropdownBenefits.vue';

const selectedMarriottLevel = ref([]);
const selectedSkywardsLevel = ref([]);
const content = APP_content.landing.sec_2;

function onSelectMarriottLevel(e) {
  const levelObj = content.marriott_list.filter(item => item.level === e.target.dataset.level);
  selectedMarriottLevel.value = levelObj;
}

function onSelectSkywardsLevel(e) {
  const levelObj = content.skywards_list.filter(item => item.level === e.target.dataset.level);
  selectedSkywardsLevel.value = levelObj;
}
</script>
